export default {

  methods: {
    focus() {
      this.$refs.input.focus();
    }
  },
}